<div [ngStyle]="{
        '--border-color': control.touched && control.invalid ? 'red' : control.disabled ? 'var(--mdc-outlined-text-field-disabled-outline-color)' : '#afcbe0'
    }" [ngClass]="{ disabled: disabled }">
  <label>{{label}}</label>

  <quill-editor #editor linkPlaceholder="https://www.matas.dk/" [placeholder]="disabled?'':placeholder" [ngClass]="{ 'ql-focus': focused }" [modules]="disabled?disabledEditorOptions:editorOptions" [readOnly]="disabled" (onContentChanged)="onContentChanged($event)" (onFocus)="handleQuillFocus()" (onBlur)="handleQuillBlur()"></quill-editor>
  @if (!disabled) {
  <mat-icon class="paste-icon" matSuffix matTooltip="Indsæt fra udklipsholder" (click)="onPasteButtonClick()">content_paste</mat-icon>
  }
  <div class="messages">
    <div class="messages-col form-validation-error-container">
      @if (control.errors?.['required']) {
      <small>Dette felt er påkrævet.</small>
      }
    </div>
    <div class="messages-col">
      @if (maxLength > 0) {
      <div class="char-text">
        {{ charCount }} / {{ maxLength }}
      </div>
      }
    </div>
  </div>

</div>
